export const TicketStatus = [
    { label: 'پاسخ داده شده', value: 'answered' },
    { label: 'در حال بررسی', value: 'pending' },
    { label: 'بسته شده', value: 'closed' },
];